<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>退费单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display:flex;align-items: center">
      <el-input size="mini" placeholder="请输入姓名或手机号进行搜索"
                v-model="orderRequest.queryOrderText"
                style="width: 200px;"></el-input>
      <el-date-picker
        v-model="orderRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
        style="margin-left: 5px;"
      >
      </el-date-picker>
      <el-button size="mini"  style="margin-left: 5px;" @click="queryRefund">查询</el-button>
    </div>
    <span style="color: #3a8ee6;font-size: 13px;margin-right: 100px">总计退费：{{zjAmount}}</span>
    <span style="color: #3a8ee6;font-size: 13px;margin-right: 100px">会员退费：{{hyAmount}}</span>
    <span style="color: #3a8ee6;font-size: 13px;margin-right: 100px">散客退费：{{skAmount}}</span>
    <el-table height="510px" :data="refundList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        prop="refundDate"
        label="退费日期"
        align="center">
      </el-table-column>
      <el-table-column
        prop="customerName"
        label="会员/散客"
        align="center"
        :formatter="refundNameFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="consumptionName"
        label="消费项目"
        align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="money"
        label="退费金额"
        align="center">
      </el-table-column>
      <el-table-column
        prop="num"
        label="退还数量"
        align="center">
      </el-table-column>
      <el-table-column
        prop="refundType"
        label="退费方式"
        align="center"
        :formatter="refundTypeFormatter">
      </el-table-column>
      <el-table-column
        prop="orderNo"
        label="所属消费单号"
        align="center"
        width="180">
      </el-table-column>
      <el-table-column
        prop="viceName"
        label="退费人"
        align="center">
      </el-table-column>
      <el-table-column
        prop="serverName"
        label="服务人员"
        align="center">
      </el-table-column>
      <el-table-column
        align="center"
        label="备注说明"
        width="250">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
      <div style="margin-top: 3px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal">
        </el-pagination>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      currentOrgId:'',
      refundList:[],
      queryText:'',
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      orderStateText:[
        {detailState:1,name:'已退费'},
        {detailState:2,name:'已作废'}
      ],
      refundTypeText:[
        {refundType:1,name:'会员余额'},
        {refundType:2,name:'现金'}
      ],
      orderRequest:{
        selectDate:'',
        startDate:'',
        endDate:'',
        orgId:'',
        queryOrderText:'',
        pageNum:'',
        pageSize:''
      },
      zjAmount:'',
      hyAmount:'',
      skAmount:''

    }
  },
  methods:{
    refundTypeFormatter(row){
      let value = "";
      for (let i = 0; i < this.refundTypeText.length; i++){
        let item = this.refundTypeText[i];
        if (row.refundType === item.refundType) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    refundNameFormatter(row){
      if (row.customerName === null){
        return '散客';
      } else {
        return row.customerName;
      }
    },
    async loadRefundAmount(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/amount/order/refund`, this.orderRequest)
      if (res.code === 200){
        this.zjAmount = res.data.zjAmount;
        this.hyAmount = res.data.hyAmount;
        this.skAmount = res.data.skAmount;
      }
    },
    async loadRefundCount(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/count/order/refund`, this.orderRequest)
      if (res.code === 200){
        this.pageTotal = res.totalPage;
      }
    },
    async loadRefundList(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/list/order/refund`, this.orderRequest)
      if (res.code === 200){
        this.refundList = res.data;
      }
    },
    queryRefund(){
      this.loadRefundCount();
      this.loadRefundList();
      this.loadRefundAmount();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRefundList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadRefundList();
    },
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.orderRequest.startDate = this.getCurrentMonthFirst();
    this.orderRequest.endDate = this.getCurrentMonthLast();
    this.queryRefund();
  }
}
</script>

<style lang="less" scoped>
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Refund.vue